import { createApp } from 'vue'
import FInputPassword from '~/js/components/inputPassword'
import { Password } from '~/js/models/password'
import { isApp, isMobile } from '~/js/helpers/user-agent-helper'

const ID_RESET_PASSWORD = 'js-customers-reset-password'

document.addEventListener('DOMContentLoaded', () => {
  const elementResetPassword = document.getElementById(ID_RESET_PASSWORD)
  if (!elementResetPassword) return

  createApp({
    name: 'TemplatesCustomersResetPassword',
    components: {
      FInputPassword,
    },
    data() {
      return {
        errorMessages: { password: '', passwordConfirm: '' },
        password: '',
        passwordConfirm: '',
        showOpenAppBtn: !isApp() && isMobile,
      }
    },
    methods: {
      onSubmit($event) {
        this.errorMessages = new Password().getErrorMessages(
          this.password,
          this.passwordConfirm
        )
        if (!Object.values(this.errorMessages).filter((v) => v).length) {
          $event.target.form.submit()
        }
      },
      openApp() {
        window.location.href = `franc-app:/tab/custom/3d9487ce?url=${encodeURI(
          window.location.href
        )}`
      },
    },
  }).mount(elementResetPassword)
})
